export default __webpack_public_path__ + "static/media/Subaru-favicon.e56b6ab3.ico";